import React from 'react';
import { FacebookSquare, Github, GithubCircle, GithubSquare, LinkedinSquare } from '../../ReactCustomIconsLibrary'


const Social = () => {
    return (
        <div className='flex flex-col gap-1  top-[50%]'>
            <div className='bg-white text-black w-[90px] text-[16px] rounded-[8px] pr-2   absolute top-[40%] left-[-55px]  z-10 flex justify-end hover:left-[2px] transition-all' >

                <a className='justify-between items-center flex p-1 gap-1' href="https://github.com/SRAKIB17/">         Github<Github size='20' color='black' /></a>
            </div>

            <div className='bg-[#0A66C2] text-white w-[110px] text-[16px] rounded-[8px] pr-2   absolute top-[50%] left-[-75px]  z-10 flex justify-end hover:left-[2px] transition-all' >

                <a className='justify-between items-center flex p-1 gap-1' href="https://www.linkedin.com/in/rakib17/" Linkedin>Linkedin <LinkedinSquare size='20' color='white' /></a>
            </div>

            <div className='bg-[#036CE4] text-white w-[110px] text-[16px] rounded-[8px] pr-2   absolute top-[60%] left-[-75px]  z-10 flex justify-end hover:left-[2px] transition-all' >

                <a className='justify-between items-center flex p-1 gap-1' href="https://web.facebook.com/rakib2017">  Facebook<FacebookSquare size='20' color='white' />
                </a>
            </div>

        </div>
    );
};

export default Social;